import { Redirect, useRouter } from 'expo-router'
import { TourCustomQuotePlanner } from '@/components/tours/TourCustomQuotePlanner'
import { PreviewFixtureRedirect } from '@/components/navigation/PreviewFixtureRedirect'
import { env } from '@/lib/env'
import { isIsolatedPreviewBuild } from '@/lib/runtime-build'
import { useCreateCustomTourQuote } from '@/lib/hooks/use-tours'
import type { TourCustomQuoteInput, TourCustomQuoteResult } from '@/lib/types/tours.types'

function ProductionTourCustomQuoteScreen() {
  const router = useRouter()
  const createQuote = useCreateCustomTourQuote()

  if (!env.isToursEnabled) {
    return <Redirect href="/(tabs)/explore" />
  }

  const handleQuote = async (input: TourCustomQuoteInput): Promise<TourCustomQuoteResult> => {
    const quote = await createQuote.mutateAsync(input)
    router.replace(`/tours/${quote.experienceId}`)
    return quote
  }

  return <TourCustomQuotePlanner onBack={() => router.back()} onQuote={handleQuote} />
}

/**
 * Defense in depth for the isolated QA application. The catalog resolves its
 * CTA to /preview/quote, but a stale deep link or manually entered /tours/quote
 * must never get as far as the production-backed mutation hook.
 */
export default function TourCustomQuoteScreen() {
  if (isIsolatedPreviewBuild) {
    return <PreviewFixtureRedirect href="/preview/quote" />
  }

  return <ProductionTourCustomQuoteScreen />
}
